export function routePrefixFn(section, participant) {
    return ['.', section.sponsorId, 'participant'].join('/');
}
